<template>
  <div class="alert-page flex flex-col items-center justify-between flex-1 my-4 w-full">
    <div class="flex flex-col items-center justify-start w-full">
      <div class="col-center image-container mb-3 w-full">
        <CustomImage :src="getImageAsset(imageName)" alt="" class="image max-w-120" fluidWidth />
      </div>
      <CustomInlineAlert
        :title="alertTitle"
        :message="alertMessage"
        :color="alertColor"
        :icon="alertIcon"
        :size="size"
        :isTablerIcon="isTablerIcon"
      />
    </div>
    <div class="flex flex-col items-center justify-end flex-1">
      <slot name="additionalContent"></slot>
    </div>
  </div>
</template>
<script lang="ts">
import CustomInlineAlert from "@/components/states/CustomInlineAlert.vue";
import { getImageAsset } from "@/methods/utils";
import { ComponentColorType, ComponentSizeType } from "@/types/componentType";
import { PropType, defineComponent } from "vue";
import CustomImage from "@/components/primitives/CustomImage.vue";

export default defineComponent({
  name: "TheAlertPage",
  components: { CustomImage, CustomInlineAlert },
  props: {
    imageName: { type: String, required: true },
    alertTitle: { type: String, required: true },
    alertMessage: { type: String, required: true },
    alertColor: { type: String as PropType<ComponentColorType>, default: "danger" },
    alertIcon: { type: String, default: "alert-triangle" },
    size: { type: String as PropType<ComponentSizeType>, default: "large" },
    isTablerIcon: { type: Boolean, default: true },
  },
  setup() {
    return { getImageAsset };
  },
});
</script>
